class CardVideos {
  constructor(section) {
    this.section = section;
    this.autoplay = this.section.dataset.autoplay === 'true';
    this.videoItems = this.section.querySelectorAll('[data-video-item]');
    this.observers = [];
    
    if (this.autoplay) {
      this.initAutoplay();
    }
  }

  initAutoplay() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.75
    };

    this.videoItems.forEach(item => {
      const video = item.querySelector('video');
      const iframe = item.querySelector('iframe');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.75) {
            this.playVideo(video, iframe);
          } else {
            this.pauseVideo(video, iframe);
          }
        });
      }, observerOptions);

      observer.observe(item);
      this.observers.push(observer);
    });
  }

  playVideo(video, iframe) {
    if (video) {
      video.play().catch(err => {
        console.log('Video autoplay prevented:', err);
      });
    } else if (iframe) {
      const src = iframe.src;
      if (src.includes('youtube.com')) {
        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      } else if (src.includes('vimeo.com')) {
        iframe.contentWindow.postMessage('{"method":"play"}', '*');
      }
    }
  }

  pauseVideo(video, iframe) {
    if (video) {
      video.pause();
    } else if (iframe) {
      const src = iframe.src;
      if (src.includes('youtube.com')) {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } else if (src.includes('vimeo.com')) {
        iframe.contentWindow.postMessage('{"method":"pause"}', '*');
      }
    }
  }

  destroy() {
    this.observers.forEach(observer => observer.disconnect());
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section-card-videos');
  sections.forEach(section => {
    new CardVideos(section);
  });
});
